import React from "react";

function AboutArea({ className }) {
  return (
    <section className={`about-area pb-120 pt-120 ${className || ""}`}>
      <div className="container">
        <div className="row align-items-center">
          <div className="col-xl-7 col-lg-6 order-0 order-lg-2">
            <div className="about-img-wrap">
              <img
                src={require(`../../assets/img/images/about_img01.jpg`)}
                alt=""
                className="wow fadeInRight"
                data-wow-delay=".4s"
              />
              <img
                src={require(`../../assets/img/images/about_img02.jpg`)}
                alt=""
                className="wow fadeInRight"
                data-wow-delay=".2s"
              />
              <div className="about-experiences-wrap">
                <div className="experiences-item">
                  <div className="icon">
                    <img
                      src={
                        require(`../../assets/img/icon/about_icon01.svg`)
                          .default
                      }
                      alt=""
                    />
                  </div>
                  <div className="content">
                    <h6 className="title">Máme více než 25 let zkušeností</h6>
                  </div>
                </div>
                <div className="experiences-item">
                  <div className="icon">
                    <img
                      src={
                        require(`../../assets/img/icon/about_icon02.svg`)
                          .default
                      }
                      alt=""
                    />
                  </div>
                  <div className="content">
                    <h6 className="title">
                      Rozsáhlá síť skladů a servisních center našich obchodních
                      partnerů
                    </h6>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="col-xl-5 col-lg-6">
            <div className="about-content">
              <div className="section-title mb-25 tg-heading-subheading animation-style3">
                <span className="sub-title tg-element-title">
                  O naší společnosti
                </span>
                <h2 className="title tg-element-title">
                  Vítáme vás na webu MARC spol. s r.o.
                </h2>
              </div>
              <p>
                Našim hlavním předmětem činnosti je nabídka a realizace dodávek
                hutních materiálů především z nerezové a ušlechtilé oceli (oceli
                nástrojové, k zušlechťování, kotlové a další).
              </p>
              <p>
                Jsme přímo napojeni na české a zahraniční výrobce i na rozsáhlou
                síť skladů a servisních center našich obchodních partnerů. Díky
                tomu jsme schopni zajistit dodávky i speciálních jakostí,
                materiálů a rozměrů. Pro své zákazníky zajišťujeme kompletní
                dodavatelský servis včetně dopravy a celního servisu.
              </p>
              <p>
                Ceny a dodací lhůty na požadovaný materiál Vám rádi sdělíme dle
                Vaší konkrétní poptávky.
              </p>

              <a href="/about" className="btn">
                Více o nás
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default AboutArea;
